import React, { useEffect, useState } from "react";
import { PageHeader } from "./Pengumuman";
import { Store, Phone, MapPin, Plus, Edit3, Trash2, Image as ImageIcon } from "lucide-react";
import { Card, CardContent } from "../components/ui/card";
import { Badge } from "../components/ui/badge";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Textarea } from "../components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../components/ui/select";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../components/ui/dialog";
import { umkmAPI, blokAPI } from "../lib/api";
import { useApp } from "../context/AppContext";
import { toast } from "sonner";

const emptyForm = { nama: "", pemilik: "", kategori: "Kuliner", blok: "", kontak: "", deskripsi: "", image: "" };

const UMKM = () => {
  const { user } = useApp();
  const canManage = user.role === "admin" || user.role === "super_admin";
  const [items, setItems] = useState([]);
  const [bloks, setBloks] = useState([]);
  const [open, setOpen] = useState(false);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState(emptyForm);

  const load = () => umkmAPI.list().then(setItems).catch(() => {});
  useEffect(() => { load(); blokAPI.list().then(setBloks).catch(() => {}); }, []);

  const openNew = () => { setEditing(null); setForm(emptyForm); setOpen(true); };
  const openEdit = (u) => { setEditing(u); setForm({ nama: u.nama, pemilik: u.pemilik, kategori: u.kategori, blok: u.blok, kontak: u.kontak, deskripsi: u.deskripsi, image: u.image || "" }); setOpen(true); };

  const handleFile = (e) => {
    const f = e.target.files?.[0]; if (!f) return;
    if (f.size > 2 * 1024 * 1024) { toast.error("Maks 2MB"); return; }
    const r = new FileReader(); r.onload = (ev) => setForm((s) => ({ ...s, image: ev.target.result })); r.readAsDataURL(f);
  };

  const submit = async () => {
    if (!form.nama || !form.pemilik) { toast.error("Nama & pemilik wajib"); return; }
    try {
      if (editing) { await umkmAPI.update(editing.id, form); toast.success("UMKM diperbarui"); }
      else { await umkmAPI.create(form); toast.success("UMKM ditambahkan"); }
      setOpen(false); load();
    } catch (e) { toast.error(e.response?.data?.detail || "Gagal"); }
  };
  const remove = async (id) => {
    if (!window.confirm("Hapus UMKM ini?")) return;
    try { await umkmAPI.remove(id); toast.success("Dihapus"); load(); } catch (e) { toast.error(e.response?.data?.detail || "Gagal"); }
  };

  return (
    <div>
      <PageHeader title="UMKM Warga" subtitle="Dukung UMKM tetangga sekitar Anda" icon={Store}
        action={<Dialog open={open} onOpenChange={setOpen}><Button className="brand-btn" onClick={openNew}><Plus className="h-4 w-4 mr-1" />Tambah UMKM</Button>
          <DialogContent className="max-w-lg"><DialogHeader><DialogTitle>{editing ? "Edit UMKM" : "Tambah UMKM"}</DialogTitle></DialogHeader>
            <div className="space-y-3 max-h-[70vh] overflow-y-auto pr-1">
              <div className="flex items-center gap-4">
                {form.image ? <img src={form.image} alt="prev" className="h-24 w-24 rounded-xl object-cover shadow border" /> : <div className="h-24 w-24 rounded-xl bg-slate-100 grid place-items-center"><ImageIcon className="h-8 w-8 text-slate-400" /></div>}
                <div><input type="file" accept="image/*" id="umkm-img" className="hidden" onChange={handleFile} /><Label htmlFor="umkm-img" className="inline-block cursor-pointer px-4 py-2 rounded-lg brand-btn text-white text-sm font-semibold">Unggah Foto Produk/Toko</Label><div className="text-xs text-slate-500 mt-1">Maks 2MB</div></div>
              </div>
              <div className="grid grid-cols-2 gap-3">
                <div><Label>Nama Usaha</Label><Input value={form.nama} onChange={(e) => setForm({ ...form, nama: e.target.value })} /></div>
                <div><Label>Pemilik</Label><Input value={form.pemilik} onChange={(e) => setForm({ ...form, pemilik: e.target.value })} /></div>
              </div>
              <div className="grid grid-cols-2 gap-3">
                <div><Label>Kategori</Label><Select value={form.kategori} onValueChange={(v) => setForm({ ...form, kategori: v })}><SelectTrigger><SelectValue /></SelectTrigger><SelectContent><SelectItem value="Kuliner">Kuliner</SelectItem><SelectItem value="Jasa">Jasa</SelectItem><SelectItem value="Toko">Toko/Retail</SelectItem><SelectItem value="Fashion">Fashion</SelectItem><SelectItem value="Lainnya">Lainnya</SelectItem></SelectContent></Select></div>
                <div><Label>Blok</Label><Select value={form.blok} onValueChange={(v) => setForm({ ...form, blok: v })}><SelectTrigger><SelectValue placeholder="Pilih blok" /></SelectTrigger><SelectContent className="max-h-[280px]">{bloks.map((b) => <SelectItem key={b.blok} value={b.blok}>{b.blok}</SelectItem>)}</SelectContent></Select></div>
              </div>
              <div><Label>Kontak (WA)</Label><Input value={form.kontak} onChange={(e) => setForm({ ...form, kontak: e.target.value })} placeholder="0812-xxxx-xxxx" /></div>
              <div><Label>Deskripsi</Label><Textarea rows={3} value={form.deskripsi} onChange={(e) => setForm({ ...form, deskripsi: e.target.value })} /></div>
            </div>
            <DialogFooter><Button variant="outline" onClick={() => setOpen(false)}>Batal</Button><Button onClick={submit} className="brand-btn">{editing ? "Simpan" : "Tambah"}</Button></DialogFooter>
          </DialogContent></Dialog>}
      />
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
        {items.map((u) => (
          <Card key={u.id} className="card-hover overflow-hidden">
            {u.image ? <img src={u.image} alt={u.nama} className="w-full h-40 object-cover" /> : <div className="w-full h-40 bg-slate-100 grid place-items-center"><ImageIcon className="h-10 w-10 text-slate-300" /></div>}
            <CardContent className="p-5">
              <div className="flex items-start justify-between mb-2">
                <Badge variant="secondary" className="bg-amber-100 text-amber-800 hover:bg-amber-100">{u.kategori}</Badge>
                {canManage && <div className="flex"><Button size="sm" variant="ghost" onClick={() => openEdit(u)}><Edit3 className="h-4 w-4" /></Button><Button size="sm" variant="ghost" onClick={() => remove(u.id)} className="text-red-600 hover:text-red-700"><Trash2 className="h-4 w-4" /></Button></div>}
              </div>
              <h3 className="font-bold text-slate-800" style={{ fontFamily: "Poppins, sans-serif" }}>{u.nama}</h3>
              <p className="text-xs text-slate-500 mb-2">oleh {u.pemilik}</p>
              <p className="text-sm text-slate-600 line-clamp-2">{u.deskripsi}</p>
              <div className="flex items-center gap-3 text-xs text-slate-500 mt-3"><span className="flex items-center gap-1"><MapPin className="h-3.5 w-3.5" />{u.blok}</span></div>
              <Button asChild className="w-full mt-3 brand-btn" size="sm"><a href={`https://wa.me/${(u.kontak || "").replace(/[^0-9]/g, "").replace(/^0/, "62")}`} target="_blank" rel="noopener noreferrer"><Phone className="h-4 w-4 mr-2" />{u.kontak}</a></Button>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
};
export default UMKM;
